import { useCallback } from "react";
import ReusableTable from "./ReusableTable";
import { fetchSubscribers } from "../util/fetchUserUtil";

export const HostTable = () => {
  const actionButtonsMeta = [
    {
      name: "New Subscriber",
      action: "create_telecom_host",
    },
  ];

  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchSubscribers(postData, "subscribers");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  return (
    <div className="flex flex-col ">
      <ReusableTable
        key={"telecom_hosts"}
        tableType={"telecom_hosts"}
        tableName={"Subscribers"}
        needGlobalFilter={true}
        needPagination={true}
        onStateChange={fetchData}
        actionButtonsMeta={actionButtonsMeta}
        isExtendingReusableColumns={true}
      />
    </div>
  );
};

export default HostTable;
